module.exports = __webpack_public_path__ + "img/bg-icho-left.a560ed82.svg";